export { default } from './NarrativeFeeds';
export { default as reducer } from './NarrativeFeeds.ducks';
export { default as sagas } from './NarrativeFeeds.sagas';

import * as actions from './NarrativeFeeds.ducks';
export { actions };
